import styled, { keyframes, css } from 'styled-components';

interface ContainerData {
  sidebar: boolean;
}
interface MenuData {
  isPageSelected: boolean;
}

const appearFromLeft = keyframes`
  from {
    opacity: 0;
    transform: translateX(-50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

export const Container = styled.div<ContainerData>``;

export const TopNavbar = styled.nav<ContainerData>`
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	max-width: 100vw;
	background-color: #eceff1;
	border-bottom: 1px solid #cfd8dc;
	z-index: 5;
	// border: 2px solid red;

	.top-navbar {
		flex: 1;
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 100%;
		height: 55px;
		padding: 5px 0;
		// border: 2px solid blue;

		button {
      padding: 2px;
      border: 0;
      background-color: transparent;
      font-size: 30px;
      color: #607d8b;
      margin-left: 10px;

			svg {
				font-size: 28px;
			};
		};

		.div-hamburger {
			width: auto;
			// border: 2px solid red;

      button .hamburger {
        display: block;
        justify-content: start;
        align-items: center;
        margin-left: 13px;
        transition: all 0.5s ease-out;
        visibility: hidden;
      };
		};

		.top-nav-content {
      display: flex;
			flex-direction: row;
			justify-content: flex-end;
      align-items: center;
			width: 80%;
			padding-right: 3.8rem; // 1.875rem; // 30px;

      form {
        width: auto;
      };

			.btn-close {
				padding: 2px;
				border: 0;
				background-color: transparent;
				color: #607d8b;
				margin-left: 10px;

				svg {
					font-size: 28px;
				};
			};
    };
  };

	// 900px
  @media (max-width: 56.25rem) {
		.top-navbar {
			.top-nav-content {
				width: 90%;
			};
		};
	};
	// 760px
  @media (max-width: 47.5rem) {
    .top-navbar {
      height: 55px;

			.top-nav-content {
				width: 100%;
				// padding-right: 10px;
				padding-right: 4rem;
			};

      button {
        &.hamburger {
          visibility: visible;
          animation: ${appearFromLeft} 0.8s;
        };
      };

      ${props => props.sidebar &&
				css`
					button {
						&.hamburger {
							display: none;
						};
					};
				`}
    };
	};
	// 479px
  @media (max-width: 29.9375rem) {
		.top-navbar {
			.top-nav-content {
				padding-right: 10px;
			};
		};
  };
`;

export const SideBar = styled.nav<ContainerData>`
	display: flex;
	justify-content: center;
	position: fixed;
	background-color: #eceff1;
	border-right: 1px solid #cfd8dc;
	width: 70px;
	height: 100%;
	top: 0;
	transition: all 0.5s ease-out;
	z-index: 6;
	// border: 2px solid blue;

	hr {
		background-color: #b0bec5;
		border: none;
		width: 70%;
		height: 1px;
		margin: 10px;
		transition: all 0.5s ease-out;
	};

	&:hover {
		transition: all 0.5s ease-out;
		width: 250px;

		hr {
			width: 220px;
		};

		.nav-menu-items {
			span {
				opacity: 1;
				visibility: visible;
				transition: all 0.5s ease-out;
			};
		};

		.nav-text {
			a {
				justify-content: flex-start;
				width: 220px;
				transition: all 0.8s ease-out;
			};
			span {
				opacity: 1;
				width: 100px;
				margin-left: 10px;
				visibility: visible;
				transition: all 0.5s ease-out;
			};
		};

		.nav-text-collapse {
			.btn-collapse {
				background-color: #eeeef2;
				width: 220px;
				transition: all 0.8s ease-out;

				> span {
					text-align: start;
					opacity: 1;
					width: 100%;
					margin-left: 10px;
					visibility: visible;
					transition: all 0.5s ease-out;
				};
			};
			.collapse {
				div {
					justify-content: flex-start;
					width: 92%;
					transition: all 0.8s ease-out;
				};
				span {
					opacity: 1;
					margin-left: 10px;
					visibility: visible;
					transition: all 0.5s ease-out;
				};
			};
		};
	};

	/* .active {
    position: fixed;
    width: 250px;
    transition: all 0.5s ease-out;

    hr {
      width: 220px;
    };

    .nav-menu-items {
      span {
        opacity: 1;
        visibility: visible;
        transition: all 0.5s ease-out;
        // width: 100px;
        // margin-left: 5px;
        // transition: opacity 0.9s; visibility 0.9s;
      }
    };

    .nav-text {
      a {
        justify-content: flex-start;
        align-items: center;
        width: 220px;
        transition: all 0.8s ease-out;
        padding-left: 0px;
      };
      span {
        opacity: 1;
        width: 100px;
        margin-left: 5px;
        visibility: visible;
        // transition: opacity 0.9s; visibility 0.9s;
        transition: all 0.5s ease-out;
      }
    };

		.nav-text-collapse {
			.btn-collapse {
				width: 220px;

				> span {
					text-align: start;
					opacity: 1;
					width: 100%;
					margin-left: 10px;
					visibility: visible;
					transition: all 0.5s ease-out;
				}
				}
    };
  }; */

	.nav-menu-items {
    width: 100%;
		overflow-y: auto;
		padding-bottom: 20px;
  };

	${props =>
		props.sidebar &&
		css`
			position: fixed;
			width: 250px;
			transition: all 0.5s ease-out;

			hr {
				width: 220px;
			};

			.nav-menu-items {
				span {
					opacity: 1;
					visibility: visible;
					transition: all 0.5s ease-out;
				};
			};

			.nav-text {
				a {
					justify-content: flex-start;
					width: 220px;
					transition: all 0.8s ease-out;
				};

				span {
					opacity: 1;
					width: 100px;
					margin-left: 10px;
					visibility: visible;
					transition: all 0.5s ease-out;
				};
			};

			.nav-text-collapse {
				.btn-collapse {
					background-color: #eeeef2;
					width: 220px;
					transition: all 0.8s ease-out;

					> span {
						text-align: start;
						opacity: 1;
						width: 100%;
						margin-left: 10px;
						visibility: visible;
						transition: all 0.5s ease-out;
					};
				};

				.collapse {
					div {
						justify-content: flex-start;
						width: 91.5%;
						transition: all 0.8s ease-out;
					};

					span {
						opacity: 1;
						margin-left: 10px;
						visibility: visible;
						transition: all 0.5s ease-out;
					};
				};
			};
  `};

  // 767px
  @media (max-width: 47.9375rem) {// 47.5rem) {
		left: -250px;

		hr {
			background-color: #b0bec5;
			border: none;
			width: 50%;
			height: 1px;
			margin: 5px;
			transition: all 0.5s ease-out;
		};

		span {
			opacity: 0;
			// width: 0px;
			transition: opacity 0.3s, visibility 0.3s;
		};

		&:hover {
			transition: all 0.5s ease-out;
			width: 250px;

			hr {
				width: 220px;
			};

			span {
				opacity: 1;
				width: 100px;
				transition: opacity 0.1s, visibility 0.1s;
			};
		};

		${props =>
		props.sidebar &&
		css`
			position: fixed;
      margin-left: 250px;
      width: 250px;

      hr {
        width: 220px;
      };

      span {
        opacity: 1;
        transition: opacity 0.9s, visibility 0.9s;
      };
		`};

		.active {
      position: fixed;
      margin-left: 250px;
      width: 250px;

      hr {
        width: 220px;
      };

      span {
        opacity: 1;
        transition: opacity 0.9s; // visibility 0.9s;
      };
    };
  };
`;

export const ItemMenu = styled.li<MenuData>`
  display: flex;
  justify-content: start;
  align-items: center;
  padding: 0.5rem 0 0.5rem 0.63rem; // 8px 0px 8px 10px;
  list-style: none;
	// border: 2px solid red;

  a {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    color: #607d8b;
    font-size: 1.025rem;
    font-weight: 500;
    width: 100%;
    height: 100%;
    padding: 0.4rem 0.5rem 0.4rem 0.5rem; // 10px 10px 10px 10px;;
    border-radius: 4px;
    white-space: nowrap;
    transition: opacity 0.8s, visibility 0.8s;
		// border: 2px solid blue;

    svg {
      font-size: 1.8rem;
      color: #455a64;
    };

    span {
			font-weight: 500;
      width: 0px;
      margin-left: 0px;
      opacity: 0;
      visibility: hidden;
      transition: all 0.5s ease-out;
    };

    ${props => props.isPageSelected &&
			css`
					color: #fff;
					background-color: #1a83ff;

					svg {
						color: #f5f5f5;
					};
      `};
  };

  // 760px
  @media (max-width: 47.5rem) {
    svg {
      margin-left: 0.8rem;
    };
  };
`;

export const ItemMenuCollapse = styled.li`
	// display: flex;
	// flex-direction: column;
  justify-content: start;
  align-items: center;
  padding: 0.5rem 0 0.5rem 0.63rem; // 8px 0px 8px 10px;
  list-style: none;
	background-color: #fafafa;
	margin-bottom: 5px;

	// border: 1px solid blue;

	.btn-collapse {
		flex: 1;
    display: flex;
		justify-content: flex-start;
    align-items: center;
    color: #607d8b;
    font-size: 1.025rem;
    font-weight: 500;
    width: 88%;
    height: 100%;
    padding: 0.4rem 0.4rem 0.4rem 0.4rem; // 10px 10px 10px 10px;
		border: none;
    border-radius: 4px;
		white-space: nowrap;
		transition: all 0.8s ease-out;

		&:hover {
			background-color: transparent;
		};
		&:focus {
			border: none;
		};

    svg {
      font-size: 1.8rem;
      color: #455a64;
    };

    span {
			display: flex;
			justify-content: space-between;
			align-items: center;
			text-align: start;
			font-weight: 500;
      width: 0;
      margin-left: 0;
      opacity: 0;
      visibility: hidden;
      transition: all 0.5s ease-out;
    };
  };

	.collapse {
		width: 100%;
	};

	// 760px
  @media (max-width: 47.5rem) {
    svg {
      margin-left: 0.8rem;
    };
  };
	// 479px
  @media (max-width: 29.9375rem) {
		.btn-collapse {
			span {
				width: 100%;
				margin-left: 10px;
				opacity: 1;
      	visibility: visible;
			};
		};
	};
`;

export const LinkItemMenuCollapse = styled.div<MenuData>`
	display: flex;
	justify-content: flex-start;
	align-items: center;
	color: #607d8b;
	font-size: 1.025rem;
	font-weight: 500;
	width: 70%;
	height: 100%;
	margin-left: 0.1rem;
	padding: 0.3rem 0.5rem 0.3rem 0.6rem; // 10px 10px 10px 10px;
	margin: 2px 0;
	border-radius: 4px;
	white-space: nowrap;
	transition: opacity 0.8s, visibility 0.8s;

	a {
		display: flex;
		width: 100%;

		svg {
			font-size: 1.3rem;
			color: #455a64;
		};

		span {
			font-size: 14px;
			font-weight: 500;
			width: 0;
			margin-left: 0;
			opacity: 0;
			visibility: hidden;
			transition: all 0.5s ease-out;
		};
	}

	${props => props.isPageSelected &&
		css`
			color: #fff;
			background-color: #1a83ff;

			a {
				svg {
				color: #f5f5f5;
			};
			}
		`};
		
	// 479px
  @media (max-width: 29.9375rem) {
		a {
			span {
			margin-left: 10px;
		};
		}
	};
`;

export const Profile = styled.li<ContainerData>`
  display: flex;
  width: 100%;
  align-items: center;
  padding: 0.313rem 0 0 1rem; //0.313rem = 5px

  img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
  };

  .avatar-name {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 2.5rem; // 2.5rem = 40px
    height: 2.5rem;
    font-size: 1.15rem;
    font-weight: 600;
    border-radius: 50%;
    color: #fff;
    white-space: nowrap;
    background-color: var(--azul-razio);
    padding: 0 0.625rem; // 0.625rem = 10px;
  };

  span {
    color: var(--azul-razio);
    white-space: nowrap;
    font-size: 1rem;
    font-weight: 500;
    margin-left: 5px;
    visibility: hidden;
    opacity: 0;
    transition: all 0.5s ease-out;
  };

  .close {
    display: flex;
    visibility: hidden;
    background-color: transparent;
    position: absolute;
    top: 5px;
    right: 5px;

    svg {
      font-size: 1.87rem;
      color: #607d8b;
    };
  };

  ${props => props.sidebar ? 
		css`
			.close {
				visibility: visible;
				animation: ${appearFromLeft} 0.8s;
			};
		`
		: css`
			.close {
				visibility: hidden;
			};
		`};

  // 760px
  @media (max-width: 47.5rem) {
    padding: 1.13rem 0 0 0.5rem;

    span {
      // display: block;
      visibility: visible;
      width: 100%;
    };

    .close {
      svg {
        font-size: 1.5rem;
      };
    };
  }
`;
